import React, { FC } from 'react';

import { RelatedDevice } from '@portals/api/organizations';

import { DeviceAvatarWithIndicator } from './DeviceAvatarWithIndicator';

interface ParentDeviceProps {
  device: RelatedDevice;
}

export const ParentDevice: FC<ParentDeviceProps> = ({ device }) => {
  if (!device) return null;

  return <DeviceAvatarWithIndicator device={device} />;
};
